import { IResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { call, takeEvery } from 'redux-saga/effects'
import { ROUTES } from '../../constants/routes'
import { sagaNavigate } from '../navigationHelper'
import { LIST_FAILURE } from './actions'

export function* listFailure() {
  yield takeEvery(LIST_FAILURE, function* (data: IResponse & Action) {
    if (data.error && data.error.code === 'PERMISSION_DENIED') {
      yield call(sagaNavigate, ROUTES.HOMEPAGE)
    }
  })
}
